import { render, staticRenderFns } from "./TemplateCapa.vue?vue&type=template&id=6e704dea&scoped=true&"
import script from "./TemplateCapa.vue?vue&type=script&lang=js&"
export * from "./TemplateCapa.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCapa.vue?vue&type=style&index=0&id=6e704dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e704dea",
  null
  
)

export default component.exports